<ng-container *ngIf="belongs_user.length > 0">
	<mat-card>
		<mat-card-content *ngIf="authIs('manager'); then manageAuth; else userAuth">
		</mat-card-content>
	</mat-card>
</ng-container>
<ng-template #manageAuth>
	<mat-list role="list">
		<mat-list-item role="listitem" *ngFor="let user of belongs_user">
			<div mat-line [ngStyle]="paymentStyle(user)">{{user.content.nickname}}</div>
			<div mat-line>{{user.username}}</div>
		</mat-list-item>
	</mat-list>
</ng-template>
<ng-template #userAuth>
	<mat-list role="list">
		<ng-container *ngFor="let user of belongs_user">
			<ng-container [ngSwitch]="user.type">
				<ng-container *ngSwitchCase="'company'">
					<mat-list-item role="listitem">
						<mat-icon mat-list-icon>location_city</mat-icon>
						<div mat-line [ngStyle]="paymentStyle(user)">{{user.content.nickname}}</div>
					</mat-list-item>
				</ng-container>
				<ng-container *ngSwitchCase="'studio'">
					<mat-list-item role="listitem">
						<mat-icon mat-list-icon>home_app_logo</mat-icon>
						<div mat-line [ngStyle]="paymentStyle(user)">{{user.content.nickname}}</div>
					</mat-list-item>
				</ng-container>
				<ng-container *ngSwitchCase="'trainer'">
					<mat-list-item role="listitem">
						<mat-icon mat-list-icon>face</mat-icon>
						<div mat-line [ngStyle]="paymentStyle(user)">{{user.content.nickname}}</div>
					</mat-list-item>
				</ng-container>
				<ng-container *ngSwitchCase="''">
					<mat-list-item role="listitem">
						<mat-icon mat-list-icon>account_circle</mat-icon>
						<div mat-line [ngStyle]="paymentStyle(user)">{{user.content.nickname}}</div>
					</mat-list-item>
				</ng-container>
			</ng-container>
		</ng-container>
	</mat-list>
</ng-template>
